'use client'
import {
  __spreadProps,
  __spreadValues
} from "./chunk-E5AFJQUS.mjs";

// src/trash/Trash.tsx
import { jsx } from "react/jsx-runtime";
var TrashIcon = (props) => {
  return /* @__PURE__ */ jsx(
    "svg",
    __spreadProps(__spreadValues({
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8.32501 5H3.75C3.33579 5 3 5.33579 3 5.75C3 6.16421 3.33579 6.5 3.75 6.5H5V19.25C5 20.7688 6.23122 22 7.75 22H16.25C17.7688 22 19 20.7688 19 19.25V6.5H20.25C20.6642 6.5 21 6.16421 21 5.75C21 5.33579 20.6642 5 20.25 5H15.675C15.3275 3.28832 13.8142 2 12 2C10.1858 2 8.67247 3.28832 8.32501 5ZM9.87803 5H14.122C13.8131 4.12611 12.9797 3.5 12 3.5C11.0203 3.5 10.1869 4.12611 9.87803 5ZM6.5 6.5V19.25C6.5 19.9404 7.05964 20.5 7.75 20.5H16.25C16.9404 20.5 17.5 19.9404 17.5 19.25V6.5H6.5ZM10 10C10.4142 10 10.75 10.3358 10.75 10.75V16.25C10.75 16.6642 10.4142 17 10 17C9.58579 17 9.25 16.6642 9.25 16.25V10.75C9.25 10.3358 9.58579 10 10 10ZM14 10C14.4142 10 14.75 10.3358 14.75 10.75V16.25C14.75 16.6642 14.4142 17 14 17C13.5858 17 13.25 16.6642 13.25 16.25V10.75C13.25 10.3358 13.5858 10 14 10Z",
          fill: "currentColor"
        }
      )
    })
  );
};

export {
  TrashIcon
};
//# sourceMappingURL=chunk-FONHX3EZ.mjs.map